import { defaultSplash } from '../../../library/dist/utilities/defaultSplash';
export const changeLoadingText = (textSelection) => {
    var _a;
    const loadingtext = (document.querySelector('#loading-text'));
    const hl = window['hl'];
    loadingtext.textContent = ((_a = hl === null || hl === void 0 ? void 0 : hl.customLoader) === null || _a === void 0 ? void 0 : _a.loader.progressText)
        ? hl.customLoader.loader.progressText[textSelection]
        : defaultSplash.loader.progressText[textSelection];
};
